import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import CompanyService from '@/services/CustomersServices/CompanyService';
import { extractError } from '@/helpers/extractApiError';

const model = {
    id: null,
    submitting: false,
    error: null,
    successOnDelete: '',
};

export const deleteCompany = createAsyncThunk(
    'company/deleteCompany',
    async (companyId, { rejectWithValue }) => {
        try {
            const response = await CompanyService.deleteCompany(companyId);
            return {
                companyId,
                data: response.data,
            };
        } catch (error) {
            return rejectWithValue(extractError(error));
        }
    },
);

const deleteCompanySlice = createSlice({
    name: 'deleteCompany',
    initialState: model,
    reducers: {
        resetDeleteCompanyStateOnError: (state) => {
            state.error = null;
        },
        resetDeleteCompanyStateOnSuccess: (state) => {
            state.successOnDelete = '';
        },
    },
    extraReducers: (builder) => {
        // delete company
        builder.addCase(deleteCompany.pending, (state, action) => {
            state.id = action.meta.arg;
            state.submitting = true;
        }).addCase(deleteCompany.fulfilled, (state) => {
            state.id = null;
            state.submitting = false;
            state.successOnDelete = 'Company deleted successfully!';
        }).addCase(deleteCompany.rejected, (state, action) => {
            state.submitting = false;
            state.error = extractError(action);
        });
    },
});

export const {
    resetDeleteCompanyStateOnError,
    resetDeleteCompanyStateOnSuccess,
} = deleteCompanySlice.actions;

export default deleteCompanySlice.reducer;
